export default function (angularModule) {
  angularModule.controller('InvoiceCtrl',
    (
      $scope,
      invoiceService,
      $stateParams
    ) => {

      $scope.allLocations = []

      $scope.pagedData = {
        locationsPaged: [],// response.users.users,
        totalResults: 0, // response.users.total,
        pageSize: 50,
        currentPageNum: 1,
      };

      $scope.loading = true

      $scope.updatePaging = () => {
        const pageStart = ($scope.pagedData.currentPageNum - 1 ) * $scope.pagedData.pageSize
        const pageEnd = $scope.pagedData.currentPageNum * $scope.pagedData.pageSize

        $scope.pagedData.locationsPaged = $scope.allLocations.slice(pageStart, pageEnd)
      }

      // noinspection JSUnresolvedVariable
      invoiceService.get($stateParams.authenticationKey, $stateParams.subscriptionId, $stateParams.invoiceId)
        .then(response => {
          $scope.allLocations = response.locations
          $scope.invoiceBillingPeriodStart = response.invoiceBillingPeriodStart
          $scope.invoiceBillingPeriodEnd = response.invoiceBillingPeriodEnd
          $scope.downloadLocationsUrl = response.downloadLocationsUrl

          $scope.pagedData.locationsPaged = $scope.allLocations.slice(0, $scope.pagedData.pageSize)
          $scope.pagedData.totalResults = $scope.allLocations.length

          $scope.loading = false
        })
    })
}
